export const tintShades = [5, 20, 35, 50];

export const filmShades = {
  frontGlass: [5, 20, 35, 50],
  rearSideGlass: [5, 20, 35, 50],
  rearWindShield: [5, 20, 35, 50],
  windshieldBrow: [5, 20, 35, 50],
};
